export default function () {
	const colors = {
		sellandstay: {
			// chart graphic
			primary: "#72E6BC",
			primaryHover: "#e9fbf5",
			secondary: "#112C42",
			secondaryHover: "rgba(17, 44, 66, 0.8)",
			third: "#EBF1F5",
			// calculator css
			colorTheme: "#112C42",
			highlighterColor: "#EBF1F5",
			mutedColor: "#EBF1F5",
			calculatorColor: "#F2D97D",
			secondColor: "#112C42",
			thirdColor: "#EBF1F5",
			radioButtonColor: "#112C42",
			backButtonColor: "#FFF",
			tooltipSrcIcon: require("../../static/information.png"),
			logoSrcIcon: require("../../static/rplus-Logo.svg"),
			logoFullSrcIcon: require("../../static/rplus-wizard-full-logo.svg"),
			phoneIcon: require("../../static/rplus-phone.svg"),
			emailIcon: require("../../static/rplus-email.svg"),
			leftArrowIcon: require("../../static/left-arrow.svg"),
			renovationIcon: require("../../static/rplus-renovation-icon.svg"),
			moneyIcon: require("../../static/geldbeutel-1.png"),
			hausIcon: require("../../static/haus-1.png"),
			wohnungIcon: require("../../static/wohnung-1.png"),
			wohnungIcon2: require("../../static/Erdgeschoss.png"),
			fenceIcon: require("../../static/grundstuck-1.png"),
			yearsPayoutIcon: require("../../static/kalender-uhr-1.png"),
			selfInformationIcon: require("../../static/selbst.png"),
			contactIcon: require("../../static/mailbox-in-1.png"),
			infoIcon: require("../../static/information.png"),
			bookIcon: require("../../static/transparenz-1.png"),
			step6Image: require("../../static/step6-desktop.webp"),
			rentIcon: require("../../static/geldborse-1.png"),
			wertIcon: require("../../static/preis-1.png"),
			dsgvoIcon: require("../../static/optionen-1.png"),
			loadingAnimation: require("../../static/Loading_Lebenswert-3.gif"),
			kalenderIcon: require("../../static/kalender-1.png"),
			grundrissIcon: require("../../static/grundriss-1.png"),
			geldtascheIcon: require("../../static/geldtasche-rplus.png"),
			step5WalletIcon: require("../../static/geldborse-1.png"),
			step5MetricsIcon: require("../../static/wertentwicklung-1.png"),
			step6LWImage: require("../../static/lw-step6-image.webp"),
			singleHouse: require("../../static/einfamilienhaus-freistehend.png"),
			duplex: require("../../static/doppelhaushalfte.png"),
			rowHouse: require("../../static/reihenhaus-1.png"),
			groundFloor: require("../../static/erdgeschoss-h.png"),
			studio: require("../../static/Studio.png"),
			wohnungNew: require("../../static/Wohnung.png"),
			maisonette: require("../../static/Maisonette.png"),
			oldHouse: require("../../static/lw-old-house.png"),
			solidHouse: require("../../static/lw-solid-house.png"),
			passiveHouse: require("../../static/lw-passive.png"),
			garage: require("../../static/garage-3.png"),
			noneFoundation: require("../../static/lw-none-foundation.svg"),
			partialFoundation: require("../../static/grundriss-1.png"),
			completeFoundation: require("../../static/voll-unterkellert.png"),
			verantwortlichIcon: require("../../static/verantwortlich-1.png"),
			wohnungneu: require("../../static/Wohnung-2.png")
		},
		ruhestandplus: {
			// chart graphic
			primary: "#E5A98C",
			secondary: "#112C42",
			third: "#EBF1F5",
			// calculator css
			colorTheme: "#E5A98C",
			highlighterColor: "#EBF1F5",
			mutedColor: "#EBF1F5",
			calculatorColor: "#F2D97D",
			secondColor: "#112C42",
			thirdColor: "#EBF1F5",
			radioButtonColor: "#000000",
			backButtonColor: "#E5A98C",
			tooltipSrcIcon: require("../../static/info-rplus.svg"),
			logoSrcIcon: require("../../static/rplus-Logo.svg"),
			logoFullSrcIcon: require("../../static/rplus-wizard-full-logo.svg"),
			phoneIcon: require("../../static/rplus-phone.svg"),
			emailIcon: require("../../static/rplus-email.svg"),
			leftArrowIcon: require("../../static/rplus-left-arrow.svg"),
			renovationIcon: require("../../static/rplus-renovation-icon.svg"),
			moneyIcon: require("../../static/rplus-money-icon.svg"),
			hausIcon: require("../../static/haus-rplus.svg"),
			wohnungIcon: require("../../static/wohnung-rplus.svg"),
			fenceIcon: require("../../static/fence-rplus.svg"),
			yearsPayoutIcon: require("../../static/rplus-years-payout.svg"),
			selfInformationIcon: require("../../static/rplus-self-information-icon.svg"),
			contactIcon: require("../../static/rplus-contact-icon.svg"),
			infoIcon: require("../../static/rplus-info-icon.svg"),
			bookIcon: require("../../static/rplus-book-icon.svg"),
			step6Image: require("../../static/step6-desktop.webp"),
			rentIcon: require("../../static/rplus-step5-wallet.svg"),
			wertIcon: require("../../static/rplus-wert-icon.svg"),
			dsgvoIcon: require("../../static/rplus-dsgvo-icon.svg"),
			loadingAnimation: require("../../static/Loading_Lebenswert-3.gif"),
			kalenderIcon: require("../../static/rplus-kalender.svg"),
			grundrissIcon: require("../../static/rplus-grundriss.svg"),
			geldtascheIcon: require("../../static/geldtasche-rplus.png"),
			step5WalletIcon: require("../../static/rplus-step5-wallet.svg"),
			step5MetricsIcon: require("../../static/rplus-step5-metrics.svg"),
			step6LWImage: require("../../static/lw-step6-image.webp"),
		},
		lebenswert: {
			// chart graphic
			primary: "#E5A98C",
			primaryHover: "rgba(229, 169, 140, 0.8)",
			secondary: "#112C42",
			secondaryHover: "rgba(17, 44, 66, 0.8)",
			third: "#EBF1F5",
			// calculator css
			colorTheme: "#E5A98C",
			highlighterColor: "#EBF1F5",
			mutedColor: "#EBF1F5",
			calculatorColor: "#F2D97D",
			secondColor: "#112C42",
			thirdColor: "#EBF1F5",
			radioButtonColor: "#112C42",
			backButtonColor: "#E5A98C",
			tooltipSrcIcon: require("../../static/information-1.png"),
			logoSrcIcon: require("../../static/rplus-Logo.svg"),
			logoFullSrcIcon: require("../../static/rplus-wizard-full-logo.svg"),
			phoneIcon: require("../../static/rplus-phone.svg"),
			emailIcon: require("../../static/rplus-email.svg"),
			leftArrowIcon: require("../../static/rplus-left-arrow.svg"),
			renovationIcon: require("../../static/rplus-renovation-icon.svg"),
			moneyIcon: require("../../static/rplus-money-icon.svg"),
			hausIcon: require("../../static/haus-rplus.svg"),
			wohnungIcon: require("../../static/wohnung-rplus.svg"),
			wohnungIcon2: require("../../static/Erdgeschoss.png"),
			fenceIcon: require("../../static/fence-rplus.svg"),
			yearsPayoutIcon: require("../../static/rplus-years-payout.svg"),
			selfInformationIcon: require("../../static/rplus-self-information-icon.svg"),
			contactIcon: require("../../static/rplus-contact-icon.svg"),
			infoIcon: require("../../static/rplus-info-icon.svg"),
			bookIcon: require("../../static/rplus-book-icon.svg"),
			step6Image: require("../../static/step6-desktop.webp"),
			rentIcon: require("../../static/rplus-step5-wallet.svg"),
			wertIcon: require("../../static/rplus-wert-icon.svg"),
			dsgvoIcon: require("../../static/rplus-dsgvo-icon.svg"),
			loadingAnimation: require("../../static/Loading_Lebenswert-3.gif"),
			kalenderIcon: require("../../static/rplus-kalender.svg"),
			grundrissIcon: require("../../static/rplus-grundriss.svg"),
			geldtascheIcon: require("../../static/geldtasche-rplus.png"),
			step5WalletIcon: require("../../static/rplus-step5-wallet.svg"),
			step5MetricsIcon: require("../../static/rplus-step5-metrics.svg"),
			step6LWImage: require("../../static/lw-step6-image.webp"),
			singleHouse: require("../../static/lw-single-family-house.png"),
			duplex: require("../../static/lw-duplex.png"),
			rowHouse: require("../../static/Reihenhaus.png"),
			groundFloor: require("../../static/lw-ground-floor.png"),
			studio: require("../../static/Studio.png"),
			wohnungNew: require("../../static/Wohnung.png"),
			maisonette: require("../../static/Maisonette.png"),
			oldHouse: require("../../static/lw-old-house.png"),
			solidHouse: require("../../static/lw-solid-house.png"),
			passiveHouse: require("../../static/lw-passive.png"),
			garage: require("../../static/lw-garage.svg"),
			noneFoundation: require("../../static/lw-none-foundation.svg"),
			partialFoundation: require("../../static/lw-partial-foundation.svg"),
			completeFoundation: require("../../static/lw-complete-foundation.svg"),
		},
	};

	let domain = 'sellandstay';

	if(window.location.hostname.endsWith("ruhestandplus.at")){
		domain = "ruhestandplus";
	}

	if(window.location.hostname.endsWith("lebenswert.de")){
		domain = "lebenswert";
	}

	const theme = colors[domain];

	// set colors to CSS
	document.documentElement.style.setProperty("--theme-color", theme.colorTheme);
	document.documentElement.style.setProperty("--highlighter-color", theme.highlighterColor);
	document.documentElement.style.setProperty("--muted-color", theme.mutedColor);
	document.documentElement.style.setProperty("--calculator-color", theme.calculatorColor);
	document.documentElement.style.setProperty("--second-color", theme.secondColor);
	document.documentElement.style.setProperty("--third-color", theme.thirdColor);
	document.documentElement.style.setProperty("--radio-button-color", theme.radioButtonColor);

	document.documentElement.style.setProperty("--back-button-color", theme.backButtonColor);

	return theme;
}
